import _to from './to';
import _from from './from';
import type { Types } from './types';

export class SS12000Map {
  static from = _from;
  static to   = _to;
}

export { Types as SS12000Types };